class FlashcardUsageAnalyticsClass {
  constructor(config = {}) {
    this.activityItemsCount = config.activityItemsCount || 0;
    this.previousUsageAnalytics = config.previousUsageAnalytics || []; // Array of equal-sized int arrays
    this.aggregatedPreviousUsageAnalytics = this.aggregateAnalytics(
      this.previousUsageAnalytics
    );
    this.currentUsageAnalytics =
      config.currentUsageAnalytics || this.getBaseUsageAnalyticsObject(); // int array
  }

  aggregateAnalytics(analyticsCollection) {
    let aggregatedAnalytics = this.getBaseUsageAnalyticsObject();
    analyticsCollection.forEach(analyticsItem => {
      analyticsItem.forEach((analyticsDataPoint, i) => {
        aggregatedAnalytics[i] += analyticsDataPoint;
      });
    });
    return aggregatedAnalytics;
  }

  getBaseUsageAnalyticsObject() {
    return Array.apply(null, { length: this.activityItemsCount }).map(() => 0);
  }

  getCurrentUsageAnalytics() {
    return this.currentUsageAnalytics;
  }
  
  getPreviousAggUsageAnalytics(){
    return this.aggregatedPreviousUsageAnalytics;
  }

  updateCurrentUsageAnalytics(activityItemNumber, usageInMilliSeconds) {
    this.currentUsageAnalytics[activityItemNumber - 1] += usageInMilliSeconds;
  }

  isUsageAlreadyComplete() {
    return this.getUsageCompletionPercentage(false) === 100;
  }

  isUsageComplete() {
    return this.getUsageCompletionPercentage(true) === 100;
  }

  hasUsageBegun() {
    return this.getUsageCompletionPercentage(true) === 0;
  }

  isActivityItemComplete(itemNumber, overallUsage) {
    let i = itemNumber - 1;
    return overallUsage === true
      ? this.aggregatedPreviousUsageAnalytics[i] +
          this.currentUsageAnalytics[i] >
          0
      : this.aggregatedPreviousUsageAnalytics[i] > 0;
  }

  getUsageCompletionPercentage(overallUsage) {
    let completedPagesCount = 0,
      timeSpendOnPage;
    Array.apply(null, { length: this.activityItemsCount }).forEach(
      (ignore, i) => {
        if (overallUsage === true) {
          timeSpendOnPage =
            this.aggregatedPreviousUsageAnalytics[i] +
            this.currentUsageAnalytics[i];
        } else {
          timeSpendOnPage = this.aggregatedPreviousUsageAnalytics[i];
        }
        if (timeSpendOnPage > 0) {
          completedPagesCount++;
        }
      }
    );
    return Math.ceil((100 * completedPagesCount) / this.activityItemsCount);
  }
}

const FlashcardUsageAnalytics = config =>
  new FlashcardUsageAnalyticsClass(config);

export default FlashcardUsageAnalytics;
